export default __webpack_public_path__ + "static/media/안주11.4c2269c0.jpg";